export default __webpack_public_path__ + "70e8a753fd0e1c057aba33755d20ad5f.png";